import { configureStore } from '@reduxjs/toolkit'
import apiPathReducer from '../redux-state/apiPath'
import bannerHandlerReducer from '../redux-state/bannerNotificationHandler'
import alertHandlerReducer from '../redux-state/alertNotificationHandler'
import dashOfficeReducer from '../redux-state/dashOffice'
import disclaimerReducer from '../redux-state/disclaimerHandler'

export default configureStore({
  reducer: {
    apiUrlPath: apiPathReducer,
    bannerHandler: bannerHandlerReducer,
    alertHandler: alertHandlerReducer,
    dashOfficeDetails: dashOfficeReducer,
    disclaimerPopUp: disclaimerReducer
  },
})